import React from "react";
import logo from "../images/REIWA_White.png";
import { Link } from "react-router-dom";

/*  to do, add icons for social media + mobile view */

export default function Footer() {
  return (
    <div className="bg-[#2f343d]">
      <footer className="relative mx-auto w-3/4 border-gray-200">
        <div className="container mx-auto px-6 text-gray-100">
          <div className="flex flex-col text-center lg:text-left justify-between py-10 lg:flex-row">
            <div>
              <img src={logo} alt="REIWA Logo" className="h-24 mx-auto" />
            </div>

            <div className="flex flex-col space-y-2 mt-6">
              <h1 className="my-4 text-xl">Useful Pages</h1>
              <span>
                <a
                  href="https://members.reiwa.com.au/s/about-us/the-institute"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  About us
                </a>
              </span>
              <span>
                <a
                  href="https://members.reiwa.com.au/s/contact-us"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  Contact
                </a>
              </span>
              <span>
                <a
                  href="https://reiwa.com.au/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  Find your dream home
                </a>
              </span>
              <span className="my-2">
                  <Link
                    className="text-sm hover:text-sky-500"
                    to="/guide"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Guide
                  </Link>
                </span>
                <span className="my-2">
                  <Link
                    className="text-sm hover:text-sky-500"
                    to="/faq"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    FAQ's
                  </Link>
                </span>

              <span>
                <a
                  href="https://members.reiwa.com.au/s/news"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  Latest news
                </a>
              </span>
            </div>

            <div className="flex flex-col space-y-2  mt-6">
              <h1 className="my-4 text-xl">Company</h1>
              <span>
                <a
                  href="https://view.publitas.com/reiwa-1/reiwa_articles/page/1"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  REIWA's Articles
                </a>
              </span>
              <span>
                <a
                  href="https://view.publitas.com/reiwa-1/reiwa_websites_terms_and_conditions/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  REIWA websites terms and conditions
                </a>
              </span>
              <span>
                <a
                  href="https://members.reiwa.com.au/s/code-of-conduct"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  Codes
                </a>
              </span>
              <span>
                <a
                  href="https://reia.com.au/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  National network
                </a>
              </span>
            </div>

            <div className="flex flex-col space-y-2  mt-6">
              <h1 className="my-4 text-xl">Privacy</h1>
              <span>
                <a
                  href="https://reiwa.com.au/privacy/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  Privacy statment
                </a>
              </span>
              <span>
                <a
                  href="https://reiwa.com.au/disclaimer/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  Disclaimer/copyright
                </a>
              </span>
            </div>

            <div className="flex flex-col space-y-2  mt-6">
              <h1 className="my-4 text-xl">Follow REIWA</h1>
              <span>
                <a
                  href="https://www.facebook.com/reiwamembers"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  Facebook
                </a>
              </span>
              <span>
                <a
                  href="https://www.instagram.com/reiwa.com.au/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  Instagram
                </a>
              </span>
              <span>
                <a
                  href="https://www.linkedin.com/company/reiwa/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  LinkedIn
                </a>
              </span>
              <span>
                <a
                  href="https://www.youtube.com/user/REIWAvideochannel"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  YouTube
                </a>
              </span>

              <span>
                <a
                  href="https://twitter.com/intent/follow?source=followbutton&variant=1.0&screen_name=reiwa"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:text-sky-500"
                >
                  Twitter
                </a>
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
